/**
* Date  : 2023/11/21
* Author : zhuql
* Declare : index
*/

import React, { useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { Parser, Player } from 'svga';

import { NOOP } from '@/constants/common';

function SvgaPlayer(props, ref) {
  const { svgaUrl, config = {}, onStart = NOOP, onEnd = NOOP } = props;

  const elementRef = useRef(null);
  const playerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    start: () => playerRef.current.start(),
    pause: () => playerRef.current.pause(),
    resume: () => playerRef.current.resume()
  }));

  useEffect(() => {
    if(svgaUrl) {
      fetchData();
    }
    return () => {
      if(playerRef.current) {
        playerRef.current.clear();
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [svgaUrl]);

  async function fetchData() {
    const parser = new Parser();
    const svga = await parser.load(svgaUrl);
    const player = new Player({
      container: elementRef.current,
      ...config
    });
    playerRef.current = player;
    player.onEnd = onEnd;
    await player.mount(svga);
    player.onStart = onStart();
    player.onEnd = () => {
      onEnd();
    };
    player.start();
  }

  return (
    <div className="SvgaPlayer-page">
      <canvas ref={elementRef} style={{ width: '100%' }} />
    </div>
  );
}

export default forwardRef(SvgaPlayer);